import { useState, useEffect } from 'react';
import { Timer } from '../Timer';

const useSecondsLeft = (timer: Timer): number => {
    const [secondsLeft, setSecondsLeft] = useState<number>(timer.currentSecondsLeft);

    useEffect(
        () =>
            timer.subscribe({
                onTick: (_, seconds) => {
                    setSecondsLeft(seconds);
                },
                onFinish: () => {
                    setSecondsLeft(0);
                },
            }),
        [],
    );

    return secondsLeft;
};

export default useSecondsLeft;
